module.exports = __webpack_public_path__ + "newprotal/img/pbs2.fb4f7607.png";